module.exports = __webpack_public_path__ + "static/img/active_vip_07.59b4fcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_vip_07.jpg
// module id = 2r5x
// module chunks = 0